var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.checkRole(_vm.item))?_c('li',{staticClass:"nav-item has-sub",class:{
    open: _vm.isOpen,
    disabled: _vm.item.disabled,
    'sidebar-group-active': _vm.isActive,
  }}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }